import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.grey[100],
    minHeight: "100vh",
  },
  mainContainer: {
    marginTop: "70px",
    padding: theme.spacing(4, 2),
    justifyContent: "center",
    background: theme.palette.grey[100],
  },
  paymentCard: {
    padding: theme.spacing(4),
    borderRadius: 12,
  },
  title: {
    fontWeight: 600,
    textAlign: "center",
  },
  orderSummary: {
    padding: theme.spacing(1, 0),
  },
  itemRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(0.5, 0),
  },
  payButton: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5),
    fontSize: "1rem",
    fontWeight: 600,
    textTransform: "none",
    backgroundColor: "#5A9E6F",
    borderRadius: 8,
    "&:hover": {
      backgroundColor: "#4a8a5f",
    },
  },
  errorText: {
    marginTop: theme.spacing(2),
    textAlign: "center",
  },
}));

export default useStyles;
